/** @jsxImportSource @emotion/react */
import { memo } from "react";
import { useNavigate, useLocation } from "react-router-dom";

// css読み込み
import { mtgBody, mtgSection } from "assets/css/stylesCss";

// ボタンコンポーネント
import NavigateButton from "components/ui/button/NavigateButton";
import BackButton from "components/ui/button/BackButton";

// リンクコンポーネント
import ExternalLink from "components/ui/link/ExternalLink";

// 注意文コンポーネント
import CautionLargeRed from "components/ui/caution/CautionLargeRed";

/**
 * エラー画面用パーツ
 * @param errorCode
 * @param errorMsg
 * @returns エラー画面
 */
export const ErrorParts = memo(({ errorCode, errorMsg }) => {
  // 画面遷移用
  const navigate = useNavigate();

  const errorList = {
    401: {
      title: "認証エラー",
      text: "ページの有効期限が切れているため、最初からやり直してください。",
      isDispTopButton: true,
    },
    403: {
      title: "遷移エラー",
      text: "不正な画面遷移を検出しました。",
      isDispTopButton: true,
    },
    404: {
      title: "指定されたURLは存在しません",
      text: "ページが見つかりませんでした。",
      isDispTopButton: true,
    },
    408: {
      title: "ネットワークエラー",
      text: "インターネットに接続できませんでした。電波の良い状態で再度お試しください。それでも解決しない場合、",
      isDispCustomerCenter: true,
      isDispTopButton: true,
      isDispBackButton: true,
    },
    500: {
      title: "一時的にご利用いただけません。",
      text: "ご不便をおかけして申し訳ございませんが、ブラウザを閉じて再度やり直していただくか、しばらく時間をおいてからお手続きください。お急ぎの場合は、",
      isDispCustomerCenter: true,
      isDispTopButton: true,
    },
  };
  if (!errorList[errorCode]) errorCode = 500;

  return (
    <>
      <CautionLargeRed>{errorList[errorCode].title}</CautionLargeRed>

      <div css={mtgSection}>
        <div css={mtgBody}>
          {errorMsg ? errorMsg : errorList[errorCode].text}
          {errorList[errorCode].isDispCustomerCenter && (
            <>
              恐れ入りますが、
              <ExternalLink
                url={"https://vivr.tokyo-gas.co.jp/contact-detail/10"}
              >
                東京ガスお客さまセンター
              </ExternalLink>
              までご連絡ください。
            </>
          )}
        </div>
      </div>

      {errorList[errorCode].isDispTopButton && (
        <NavigateButton
          isActive={true}
          fn={() => navigate("/")}
        >
          トップページへ
        </NavigateButton>
      )}
      {errorList[errorCode].isDispBackButton && <BackButton />}
    </>
  );
});

/**
 * エラー画面
 */
const Error = memo(() => {
  // エラーコード
  const location = useLocation();
  return (
    <ErrorParts
      errorCode={location.state?.errorCode}
      errorMsg={location.state?.errorMsg}
    ></ErrorParts>
  );
});

export default Error;
